
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ILicensingInfo } from '../types/ILicensingInfo';

export interface IGetLicensingInfoParams {
}

export interface IGetLicensingInfoResult extends ILicensingInfo {
}

export class GetLicensingInfoRequest extends Request<IGetLicensingInfoParams, IGetLicensingInfoResult> {
  constructor(params: IGetLicensingInfoParams = {}) {
    super('getLicensingInfo', params);
  }
}
